import React, { Component } from 'react';
import './index.css'
import {get} from 'lodash'
class Payment extends Component {
  render() {
    let chargeResult = this.props.chargeResult
    let amount = get(chargeResult, 'amount')
    let last4 = get(chargeResult, 'source.last4')
    // Online orders may be paid partly or fully by a gift card (afoodapart2 orders.js).
    // A fully covered order has paymentType CARD and no charge at all.
    const giftCard = this.props.giftCard
    const giftLast4 = get(giftCard, 'last4')
    const giftDollars = (get(giftCard, 'appliedCents', 0) / 100).toFixed(2)
    const isCash = this.props.paymentType === 'CASH'
    let tips = this.props.tips
    const toDoRefundInCents = this.props.toDoRefundInCents

    return (
      // <div className="payment">
      //   Paid ${amount / 100} via card: *{last4}
      //
      //   {tips && <div className="tips">
      //     Tipped ${tips / 100} via card: *{last4}
      //     {/* <br/>
      //     (${Math.floor(tips * 0.97 - 30) / 100} after cc process fees) */}
      //   </div>}
      //   {!tips && <div>did not tip</div>}
      //
      //   {(toDoRefundInCents > 0) && <div>
      //     Refund to Card: ${toDoRefundInCents / 100}
      //   </div>}
      //   {(toDoRefundInCents > 0) && <div>
      //     (may take up to 10 business days to reflect on credit card)
      //   </div>}
      // </div>
      <div className="payment">
        {!giftCard && <span>Paid via card *{last4}</span>}
        {giftCard && isCash && <span>Gift card ····{giftLast4} paid ${giftDollars}, collect the rest in person</span>}
        {giftCard && !isCash && last4 && <span>Paid via gift card ····{giftLast4} (${giftDollars}) + card *{last4}</span>}
        {giftCard && !isCash && !last4 && <span>Paid via gift card ····{giftLast4}</span>}
        {(toDoRefundInCents > 0) && <div>
          Refund to Card: ${toDoRefundInCents / 100}
        </div>}
        {(toDoRefundInCents > 0) && <div>
          (may take up to 10 business days to reflect on credit card)
        </div>}
      </div>
    );
  }
}

export default Payment;
